import React from 'react';
import PropTypes from 'prop-types';
import i39 from 'assets/images/i39.svg';
import styled from 'react-emotion';

const propTypes = {
  speed: PropTypes.oneOf([2, 3, 4, 5]).isRequired,
  hideAt: PropTypes.number.isRequired,
};
const defaultProps = {
  speed: 5,
  hideAt: 700,
};

/**
 * Component listens to scroll event on window element. If scrollTop bigger than <hideAt>
 * displays button to scroll up the page with speed <speed>.
 * how to use: <ScrollTop speed={50} hideAt={500} />
 */
class ScrollTop extends React.Component {
  html = document.documentElement
  state = { show: false, intervalId: 0 }
  componentDidMount() {
    window.addEventListener('scroll', () => {
      if (this.html.scrollTop > this.props.hideAt && this.state.show === false) {
        this.setState({ show: true });
      } else if (this.html.scrollTop <= this.props.hideAt && this.state.show === true) {
        this.setState({ show: false });
      }
    });
  }
  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - window.pageYOffset / this.props.speed);
  }
  scrollToTop = () => {
    let intervalId = setInterval(this.scrollStep, 20);
    this.setState({ intervalId });
  }
  render() {
    if(this.state.show === false) return null;
    return <Button onClick={this.scrollToTop} title="Wróć na górę"><img src={i39} alt="na górę" /></Button>;
  }
}

const Button = styled('button')`
  position: fixed;
  z-index: 1;
  right: 10px;
  bottom: 10px;
  transition: 100ms;
  :hover {
    box-shadow: 1px 1px 1px #ccc;
    background: #f2f2f2;
  }
  img {
    transform: rotate(90deg);
  }
`;

ScrollTop.propTypes = propTypes;
ScrollTop.defaultProps = defaultProps;
export default ScrollTop;


// WEBPACK FOOTER //
// ./src/components/ScrollTop.jsx